import React, { useState } from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import IconSend from "assets/icons/Red-Send-Circle.svg";
import IconMedia from "assets/icons/media-icon.svg";

function Toolbar({ props, checkChatSession, loadingState }) {
  const [newMessage, setNewMessage] = useState("");
  const textareaRef = React.useRef(null);

  const sendMessage = async (event) => {
    event.preventDefault();
    if (newMessage) {
      const message = newMessage;
      setNewMessage("");

      try {
        let sending = await props.conversation.sendMessage(message);
        if (sending !== null) {
          let params = {
            read_by_doctor: 1,
            read_by_user: 0,
          };
          props.updateReadStatus(params);
        }
      } catch (e) {
        console.log("Coudln't send message = ", e);
        alert("Unable to initiate chat");
      }
    }
  };

  const handleMsgChange = (message) => {
    textareaRef.current.style.height = "inherit";
    // Set height
    textareaRef.current.style.height = `${Math.max(
      textareaRef.current.scrollHeight,
      16
    )}px`;
    setNewMessage(message);
  };

  const MediaInput = () => {
    const sendMedia = async (e) => {
      // event.preventDefault();
      if (e.target.files.length >= 1) {
        let file = e.target.files[0];

        if (!file.type.includes("image/")) {
          alert("Only image is allow to be uploaded");
          return;
        }
        if (file.size > 2000000) {
          alert("File size cannot exceed more than 2MB");
          return;
        }

        const formData = new FormData();
        formData.append("file", file);

        let sending = await props.conversation.sendMessage(formData);
        if (sending !== null) {
          let params = {
            read_by_doctor: 1,
            read_by_user: 0,
          };
          props.updateReadStatus(params);
        }
      }
    };

    return (
      <InputGroup.Text className="media-icon">
        <label htmlFor="media-input">
          <img src={IconMedia} alt="media-icon" />
        </label>
        <input
          type="file"
          id="media-input"
          className="media-input"
          onChange={(e) => sendMedia(e)}
          accept="image/*"
        />
      </InputGroup.Text>
    );
  };

  // disable toolbar if chat has not started
  if (checkChatSession(props.chat)) {
    return <div className="toolbar">Chat has ended</div>;
  } else if (!props.chat.hasStarted && !props.chat.open_session) {
    return <div className="toolbar">Session not yet started.</div>;
  } else {
    return (
      <div className="toolbar">
        <Form onSubmit={sendMessage}>
          <InputGroup className="message-input-group">
            <Form.Control
              placeholder={"Type a message"}
              as="textarea"
              name={"message"}
              autoComplete={"off"}
              disabled={loadingState !== "ready"}
              onChange={(e) => handleMsgChange(e.target.value)}
              value={newMessage}
              className="message-field"
              rows={1}
              maxLength={1600}
              ref={textareaRef}
            />
            <MediaInput />
          </InputGroup>
          <Button className="send-btn" type={"submit"} variant="link">
            <img src={IconSend} alt="icon-send" />
          </Button>
        </Form>
      </div>
    );
  }
}

export default Toolbar;
